import { ArticlePDFClickEventHandler } from "./event-handle"

export * from "./event-helper"

export default new ArticlePDFClickEventHandler()
